import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, AlertCircle, Loader2 } from 'lucide-react';
import AdminLayout from '../components/AdminLayout';
import { getCandidateListBySource } from '../services/adminApi';

function formatDate(value) {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return value;
  }
}

// BE endpoint'e göre alan adları PascalCase ya da camelCase gelebiliyor (bkz. CLAUDE.md).
// location/title, GetCandidateListBySource'un dokümante edilmiş şemasında yok,
// BE ileride eklerse (ör. city/pozisyon veya en son CV'nin unvanı) burada
// olası alan adları savunmacı biçimde denenir, hiçbiri gelmezse '-' gösterilir.
function normalizeCandidate(raw) {
  return {
    id: raw.id ?? raw.Id,
    name: raw.name ?? raw.Name ?? '',
    surname: raw.surname ?? raw.Surname ?? '',
    email: raw.email ?? raw.Email ?? '',
    phone: raw.phone ?? raw.Phone ?? '',
    location: raw.location ?? raw.Location ?? raw.city ?? raw.City ?? '',
    title: raw.title ?? raw.Title ?? raw.position ?? raw.Position ?? '',
    createdAt: raw.createdAt ?? raw.CreatedAt,
  };
}

const AdminCandidatesPage = () => {
  const navigate = useNavigate();
  const [candidates, setCandidates] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await getCandidateListBySource('isbulsun.com');
        if (cancelled) return;

        if (!res.ok || res.status === false) {
          setError(res.message || 'Aday listesi alınamadı.');
          setCandidates([]);
          return;
        }

        setCandidates((res.data || []).map(normalizeCandidate));
      } catch {
        if (!cancelled) {
          setError('Sunucuya ulaşılamadı. Bağlantınızı kontrol edin.');
          setCandidates([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AdminLayout title="Adaylar">
      <div className="admin-panel-card">
        {loading && (
          <div className="admin-placeholder">
            <Loader2 className="spin" />
            <h3>Yükleniyor...</h3>
          </div>
        )}

        {!loading && error && (
          <div className="admin-placeholder">
            <AlertCircle />
            <h3>Aday listesi alınamadı</h3>
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && candidates?.length === 0 && (
          <div className="admin-placeholder">
            <Users />
            <h3>Henüz aday yok</h3>
            <p>isbulsun.com üzerinden kayıt olan aday bulunmuyor.</p>
          </div>
        )}

        {!loading && !error && candidates?.length > 0 && (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Ad Soyad</th>
                  <th>Pozisyon</th>
                  <th>İl</th>
                  <th>E-posta</th>
                  <th>Telefon</th>
                  <th>Kayıt Tarihi</th>
                </tr>
              </thead>
              <tbody>
                {candidates.map((c) => (
                  <tr
                    key={c.id}
                    className="admin-table-row--clickable"
                    onClick={() => navigate(`/panel/adaylar/${c.id}`)}
                  >
                    <td>{[c.name, c.surname].filter(Boolean).join(' ') || '-'}</td>
                    <td>{c.title || '-'}</td>
                    <td>{c.location || '-'}</td>
                    <td>{c.email || '-'}</td>
                    <td>{c.phone || '-'}</td>
                    <td>{formatDate(c.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminCandidatesPage;
